import React, { Component } from "react";
import ReactDOM from 'react-dom';
import styled from "styled-components";
import moment from "moment";
import { Icon } from "antd";
import { connect } from "react-redux";
import closeIcon from "../../../../../../assets/icons/close-icon.svg";
import DateSelectorComponent from "./DateSelector";
import { CustomModalMob } from "../../style";
import { TimeFrames, ClearTime } from "./styles";
import {
  QASection,
  InfoContentWrapper,
  InfoWrapper,
  DisplayFlexOkay,
  PrimaryButtonOkay,
  PopHeader,
  QASectionWrapper,
  IconWrap,
  CloseIcon
} from "./styles";
import { milliToDate, recordError } from "../../../../../../utils/commonUtil";
import { ActivityTimeFrameDerivedState } from "../../selectors";

let currentDates = [];
let cDate = new Date();
let todayDate = milliToDate(cDate);
let beforeMonth = moment(cDate)
  .subtract(30, "days")
  .format("L");
currentDates[0] = beforeMonth;
currentDates[1] = todayDate;

class TimeFrameComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: { 1: false, 2: false, 3: false },
      dates: ""
    };
    this.toTimeFrame = this.toTimeFrame.bind(this);
    this.setdates = this.setdates.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }
  showModal = () => {
    try {
      this.setState(prevState => {
        let prevStateVisible = { ...prevState.visible };
        prevStateVisible[this.props.tab] = true;
        return {
          visible: { ...prevStateVisible }
        };
      });
    } catch (error) {
      recordError(error);
    }
  };

  handleOk = currentDates => {
    try {
      if(this.props.startDate &&  this.props.endDate) {
        const dateArr = [];
        dateArr.push(this.props.startDate);
        dateArr.push(this.props.endDate)
        this.toTimeFrame({ dateString: dateArr });
      }
      this.setState(
        prevState => ({
          visible: {
            ...prevState.visible,
            [this.props.tab]: false
          }
        }),
        () => {
          if (currentDates) {
            if (this.state.dates.length < 1) {
              this.setState({ dates: currentDates });
              return this.props.dateValues(currentDates);
            }
            // return this.props.dateValues("");
          }
        }
      );
    } catch (error) {
      recordError(error);
    }
  };

  handleMobileOk = () => {
    try {
      const dateArr = [];
      this.props.startDate ? dateArr.push(this.props.startDate) : dateArr.push(moment(beforeMonth, "MM/DD/YYYY"));
      this.props.endDate ? dateArr.push(this.props.endDate) : dateArr.push(moment(todayDate, "MM/DD/YYYY"));
      this.toTimeFrame({ dateString: dateArr });
      this.setState(
        prevState => ({
          visible: {
            ...prevState.visible,
            [this.props.tab]: false
          }
        }))
    } catch (error) {
      recordError(error);
    }
  }

  handleCancel = e => {
    try {
      this.setState(prevState => ({
        visible: {
          ...prevState.visible,
          [this.props.tab]: false
        }
      }));
    } catch (error) {
      recordError(error);
    }
  };

  startDate = dates => {
    currentDates[0] = dates;
  };
  endDate = dates => {
    currentDates[1] = dates;
  };

  toTimeFrame = dates => {
    if (!dates) {
      this.props.dateValues("");
      this.setState({ dates: "" });
    } else {
      this.setState({ dates: dates.dateString }, () => {});
      this.props.dateValues(dates.dateString);
    }
  };

  clearDates = () => {
    try {
      this.toTimeFrame("");
    } catch (error) {
      recordError(error);
    }
  };

  setdates = dates => {
    this.setState({ dates }, () => this.props.dateValues(dates));
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.cleared !== prevProps.cleared) {
      if (this.props.cleared === true) {
        if (this.props.cleared && prevProps.tab == this.props.tab) {
          if (this.state.dates !== "") {
            this.clearDates();
          }
          this.props.clearedFunc(false);
        }
      } else return null;
    }
    if (this.props.tab !== prevProps.tab) {
      this.setState(prevState => ({
        visible: {
          ...prevState.visible,
          [prevProps.tab]: false,
          [this.props.tab]: false
        }
      }));
    }
    if (this.props.cleared !== prevProps.cleared) {
      this.clearDates();
    }
  }

  render() {
    return (
      <>
        {this.state.dates ? (
          <TimeFrames id="dateform">
            <ClearTime onClick={this.clearDates}>
              {moment(this.state.dates[0]).format("L")} -
              {moment(this.state.dates[1]).format("L")}
              <CloseIcon
                src={closeIcon}
                onClick={this.closeAlert}
                className="mr-icon"
              />
            </ClearTime>
          </TimeFrames>
        ) : (
          <TimeFrames id="dateform" onClick={this.showModal}>
            -Select-
          </TimeFrames>
        )}
        {window.screen.availWidth < 576 ? (
          this.state.visible[this.props.tabKey] ? ReactDOM.createPortal((
            <InfoWrapper
                className={
                  !this.state.visible[this.props.tab] ? "hidden" : "kkkk"
                }
              >
                <InfoContentWrapper data-test = "dateform">
                  <IconWrap onClick={e => this.handleCancel(e)}>
                    <Icon type="close" />
                  </IconWrap>
                  <PopHeader>Pick Time Frame</PopHeader>
                  <div>
                    <QASectionWrapper>
                      <DateSelectorComponent                
                        open={this.state.visible[this.props.tab]}
                        startDate={this.startDate}
                        defaultValue={[
                          moment(beforeMonth, "MM/DD/YYYY"),
                          moment(todayDate, "MM/DD/YYYY")
                        ]}
                        endDate={this.endDate}
                        dateValues={this.props.dateValues}
                        toTimeFrame={this.toTimeFrame}
                        tabKey={this.props.tabKey}
                      />
                    </QASectionWrapper>
                    <DisplayFlexOkay>
                      <PrimaryButtonOkay
                      id="btnFilter"
                        onClick={() => {
                          this.handleMobileOk(currentDates);
                        }}
                      >
                        Filter
                      </PrimaryButtonOkay>
                    </DisplayFlexOkay>
                  </div>
                </InfoContentWrapper>
              </InfoWrapper>
            
          ), document.getElementById('mobileModal')) : null
        ) : (
          <>
            {
              <InfoWrapper
                className={
                  !this.state.visible[this.props.tab] ? "hidden" : "kkkk"
                }
              >
                <InfoContentWrapper>
                  <IconWrap onClick={e => this.handleCancel(e)}>
                    <Icon type="close" />
                  </IconWrap>
                  <PopHeader>Pick Time Frame</PopHeader>
                  <div>
                    <QASectionWrapper>
                      <DateSelectorComponent
                        open={this.state.visible[this.props.tab]}
                        startDate={this.startDate}
                        defaultValue={[
                          moment(beforeMonth, "DD/MM/YYYY"),
                          moment(todayDate, "DD/MM/YYYY")
                        ]}
                        endDate={this.endDate}
                        dateValues={this.setdates}
                        toTimeFrame={this.toTimeFrame}
                        tabKey={this.props.tabKey}
                      />
                    </QASectionWrapper>
                    <DisplayFlexOkay>
                      <PrimaryButtonOkay
                        onClick={() => {
                          this.handleOk(currentDates);
                        }}
                      >
                        Filter
                      </PrimaryButtonOkay>
                    </DisplayFlexOkay>
                  </div>
                </InfoContentWrapper>
              </InfoWrapper>
            }
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  ...ActivityTimeFrameDerivedState(state.toJS()),
});

export default connect(
  mapStateToProps,
  null
)(TimeFrameComponent);
